import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { Map } from 'immutable';

import { fetchQueue } from 'flow/actions/pbx-actions';
import { fetchDefaultSounds } from 'flow/actions/sounds-actions';
import Page from 'flow/components/Setting/Page';
import Divider from 'flow/components/ui-components/Divider';
import Loading from 'flow/components/ui-components/Loading';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import { PbxParams } from 'flow/types/Params';
import Queue from 'flow/types/Queue';
import { routes } from 'flow/types/routes';

import { TypedMap } from 'flow/types/TypedMap';

const PbxWelcomeMessage = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { i18next } = useAppContext();

    const { entityKey } = useParams<PbxParams>();

    useEffect(() => {
        dispatch(fetchQueue(entityKey));
    }, [dispatch, entityKey]);

    useEffect(() => {
        dispatch(fetchDefaultSounds());
    }, [dispatch]);

    const pbxDetails: TypedMap<Queue> = useAppSelector((state) =>
        state.pbx.getIn(['queues', entityKey], Map()),
    );

    const profiles = pbxDetails.get('profiles');

    if (!pbxDetails || !profiles) {
        return <Loading />;
    }

    const openProfile = profiles
        .filter((profile) => profile.get('plusId') === 0)
        .first();
    const unavailableProfiles = profiles.filter(
        (profile) => profile.get('available') === false,
    );

    return (
        <Page
            header="Queue.Settings.List.WelcomeMessage"
            onClickBack={() =>
                history.push(
                    generatePath(routes['pbx.queues.entityKey.settings'], {
                        entityKey,
                    }),
                )
            }
        >
            <div className="flex h-13 items-center">
                {i18next.t('Queue.WelcomeMessage.Header.Description')}
            </div>

            <Divider />

            <RouteLink
                to={generatePath(
                    routes['pbx.queues.entityKey.settings.welcomemessage.open'],
                    { entityKey },
                )}
                description={pbxDetails.getIn(['welcomeSound', 'name'])}
            >
                {openProfile?.get('description')}
            </RouteLink>

            {unavailableProfiles?.map((profile) => (
                <RouteLink
                    key={profile.get('key')}
                    to={generatePath(
                        routes[
                            'pbx.queues.entityKey.settings.welcomemessage.profileKey'
                        ],
                        { entityKey, profileKey: profile.get('key') },
                    )}
                >
                    {profile.get('description')}
                </RouteLink>
            ))}

            <Divider />

            <RouteLink
                to={generatePath(
                    routes[
                        'pbx.queues.entityKey.settings.welcomemessage.sounds'
                    ],
                    { entityKey },
                )}
            >
                {i18next.t('pbx.user_sounds')}
            </RouteLink>
        </Page>
    );
};

export default PbxWelcomeMessage;
